import { render, staticRenderFns } from "./ManagementServicesPage.vue?vue&type=template&id=551be106"
import script from "./ManagementServicesPage.vue?vue&type=script&lang=js"
export * from "./ManagementServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementServicesPage.vue?vue&type=style&index=0&id=551be106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports